import { supabase } from "@/lib/supabase";
import { clearActiveOrgId } from "@/api/session";
import { CALENDAR_TZ_STORAGE_KEY } from "@/calendar/TimezoneSelect";
import { CALENDAR_FILTERS_STORAGE_KEY } from "@/calendar/CalendarPage";
import { MONITORS_WIZARD_IR_KEY_PREFIX } from "@/monitors/hooks/useDraftIRStash";

/**
 * Sign the current user out and clear per-user / per-org client state so the
 * next signed-in user on the same device doesn't inherit the previous user's
 * org context, calendar filters, or in-flight monitor draft IR.
 *
 * Device-level preferences (theme, cookie consent, mobile-interstitial ack)
 * are intentionally retained — they belong to the device, not the session.
 */
export async function signOut(): Promise<void> {
  clearActiveOrgId();
  localStorage.removeItem(CALENDAR_TZ_STORAGE_KEY);
  localStorage.removeItem(CALENDAR_FILTERS_STORAGE_KEY);

  // Monitor wizard IR drafts live in sessionStorage (tab-scoped) but the
  // sign-out + sign-in flow happens in-tab, so they leak unless we clear.
  const wizardKeys: string[] = [];
  for (let i = 0; i < sessionStorage.length; i++) {
    const key = sessionStorage.key(i);
    if (key && key.startsWith(MONITORS_WIZARD_IR_KEY_PREFIX)) {
      wizardKeys.push(key);
    }
  }
  for (const key of wizardKeys) sessionStorage.removeItem(key);

  await supabase.auth.signOut();
}
